module.exports = "/packs/images/svg/ireland/accessibility/accessible_parking~a3de89554b6251af62680a39fb8501a1.svg";